module.exports = __webpack_public_path__ + "static/img/home-header.1dd5860.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home-header.jpg
// module id = AtPT
// module chunks = 11